export const API_END_POINT =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";
export { getCompanyId } from "../helper/utils/companyId";
